<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Master Data" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <!-- <form> -->
          <div class="row mb-5">
            <div class="col-md-6">
              <FormRow
                v-for="row in leftForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <div class="row mt-2">
                <div class="col-md-12">
                  <button
                    type="submit"
                    @click="handleForm"
                    class="btn btn-primary btn-with-icon-left float-right text-uppercase ml-3"
                  >
                    <i class="material-symbols-outlined">check</i>
                    Simpan Tindakan
                  </button>
                  <!-- <router-link
                    class="btn btn-outline-danger btn-no-outline float-right"
                    to="/master/tindakan"
                    >Batalkan</router-link
                  > -->
                  <a
                    class="
                      btn btn-outline-danger btn-no-outline
                      float-right
                      text-uppercase
                    "
                    @click="() => goBack('/master/tindakan')"
                    >Batalkan
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- </form> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
// import FormGroup from "@/components/FormGroup.vue";
import FormData from "form-data";
// import { HTTP } from "@/config.js";
let data = {
  title: "Tindakan Baru",
  backBtn: "/master/tindakan",
  actionBtn: [],
  breadcrumb: [
    { title: "Tindakan", link: "/master/tindakan" },
    { title: "Baru", active: true },
  ],
};

export default {
  name: "TindakanForm",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    // FormGroup
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: data,
      leftForm: [
        {
          colnum: 1,
          columns: [
            {
              name: "kategori",
              type: "select",
              label: "Pilih Jenis Tindakan",
              options: [
                {
                  label: "Tindakan Medis Spesifik",
                  value: "Tindakan Medis Spesifik",
                },
                { label: "Tindakan Medis Umum", value: "Tindakan Medis Umum" },
                { label: "Operasi", value: "Operasi" },
              ],
            },
          ],
        },
        {
          colnum: 2,
          columns: [
            { name: "kode", type: "text", label: "Kode Tindakan", colwidth: 5 },
            { name: "nama", type: "text", label: "Nama Tindakan", colwidth: 7 },
          ],
        },
        {
          colnum: 2,
          columns: [
            {
              name: "biaya",
              type: "money",
              label: "Biaya Tindakan",
              colwidth: 5,
            },
            {
              name: "dokter_persen",
              type: "percentage",
              label: "Bagian Dokter",
              colwidth: 3,
            },
            {
              name: "petugas_persen",
              type: "percentage",
              label: "Bagian Petugas",
              colwidth: 3,
            },
          ],
        },
        {
          colnum: 1,
          columns: [
            {
              name: "ditanggung",
              type: "radio",
              label: "ditanggung",
              options: [
                { label: "Ya", value: "1" },
                { label: "Tidak", value: "0" },
              ],
            },
          ],
        },
      ],
      formSet: {
        ditanggung: "",
        kategori: "",
        kode: "",
        nama: "",
        biaya: "",
        dokter_persen: 0,
        petugas_persen: 0,
      },
    };
  },
  methods: {
    goBack(url) {
      if (window.history.length <= 1) {
        this.$router.push({ path: url });
      } else {
        this.$router.go(-1);
      }
    },
    handleForm: async function() {
      //console.log(this.formSet.no_rm);
      this.errors = [];
      let formData = new FormData();
      var self = this;
      let valid = this.validateForm();
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          formData.append(key, self.formSet[key]);
        });
        try {
          let result = await this.$store.state.HTTP.post("tindakan", formData);
          //console.log(result);
          if (result.status == "200") {
            this.$router.push(`/master/tindakan`);
          } else {
            //console.log(result.status);
            this.errors.push(result.status);
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
        }
      } else {
        //console.log("tidak valid");
      }
    },
    handleChange(e) {
      this.formSet[e.target.name] = e.target.value;
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      this.leftForm = this.leftForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            column.error = "";
          }
          column.value = self.formSet[column.name];
          return column;
        });
        return row;
      });
      return valid;
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {},
};
</script>
